export default __webpack_public_path__ + "static/media/flag_fill.a86cce98.svg";